module.exports = __webpack_public_path__ + "officialStatic/img/jabilLogo.5b3ce5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/jabilLogo.png
// module id = rXtf
// module chunks = 0